// import { Filtro } from '@/store/CommonStore'
import { useCommonStore } from "@/store/CommonStore";
import { MaterialExtend } from "@/store/MaterialesStore";
import { ProductoAcabadoExtend } from "@/store/ProductosAcabadoStore";
import { ProyectoExtend } from "@/store/ProyectosStore";
import {
  EstadosTareas,
  TareaBBDDExtend,
  useTareasStore,
} from "@/store/TareasStore";
import moment from "moment";

export default function () {
  const dateToString = (date: string | Date | undefined) => {
    if (date) {
      return moment(date).format("DD/MM/YYYY");
    }
    return "";
  };
  const dateToStringFormatter = (row: any, column: any, cellValue: any) => {
    if (cellValue) {
      return moment(cellValue).format("DD/MM/YYYY");
    }
    return "";
  };
  const groupBy = (array: any[], key: string) => {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      return result;
    }, {});
  };
  const getDistinct = <T, K extends keyof T>(
    data: T[],
    property: K
  ): T[K][] => {
    const allValues = data.reduce((values: T[K][], current) => {
      if (current[property]) {
        values.push(current[property]);
      }
      return values;
    }, []);

    return [...new Set(allValues)];
  };

  const DaysSince = (date: string) => {
    const today = moment().startOf("day");
    const pastDate = moment(date).startOf("day");
    const differenceInDays = today.diff(pastDate, "days");
    return differenceInDays;
  };

  const GetClassByStatus = (estado: string) => {
    switch (estado) {
      case EstadosTareas.NotStarted:
        return "NoIniciado";
      case EstadosTareas.OnTime:
        return "EnCurso";
      case EstadosTareas.Delayed:
        return "Delayed";
      case EstadosTareas.Finished:
        return "Finalizado";
      case EstadosTareas.ProyectoNoIniciado:
        return "ProyectoNoIniciado";
      default:
        break;
    }

    return "";
  };
  
  const removeSpecialCharacters = (name: string) => {
    const charMap: Record<string, string> = {
      à: "a", á: "a", ä: "a", â: "a",
      è: "e", é: "e", ë: "e", ê: "e",
      ì: "i", í: "i", ï: "i", î: "i",
      ò: "o", ó: "o", ö: "o", ô: "o",
      ù: "u", ú: "u", ü: "u", û: "u",
      ñ: "n", ç: "c"
    };
  
    // Reemplazar caracteres acentuados
    name = name.replace(/[àáäâèéëêìíïîòóöôùúüûñç]/g, match => charMap[match]);
  
    // Eliminar diacríticos restantes
    name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  
    // Eliminar caracteres prohibidos por SharePoint y Entra
    name = name.replace(/[~"#%&*:<>?/\\{|}^@]/g, "");
  
    // Reemplazar espacios múltiples por uno solo
    name = name.replace(/\s+/g, " ");
  
    // Eliminar puntos al final y espacios al principio/final
    name = name.trim().replace(/\.+$/, "");
  
    // Opcional: reemplazar espacios por guiones bajos o guiones
    // name = name.replace(/\s+/g, "_");
  
    return name;
  }
  
  
  const findMissingNumber = (arr: number[]): number => {
    const n = arr.length + 1;
    const totalSum = (n * (n + 1)) / 2;
    const arraySum = arr.reduce((acc, num) => acc + num, 0);
    return totalSum - arraySum;
  };
  const generateKeyEquipos = (
    equipo: string,
    subequipo: string | null
  ): string => {
    const sanitize = (str: string): string =>
      str.replace(/\s+/g, "").replace(/[^\w]/g, "");
    return subequipo
      ? `${sanitize(equipo)}+${sanitize(subequipo)}`
      : sanitize(equipo);
  };
  const keyExistsEquipos = (key: string): boolean => {
    const CommonStore = useCommonStore();
    const TareasStore = useTareasStore();
    for (const equipo of CommonStore.Equipos) {
      if (
        equipo.Key === key &&
        TareasStore.TareasConfiguracion.some((t) => t.Key === key)
      ) {
        return true;
      }
      for (const subequipo of equipo.SubEquipos) {
        if (
          subequipo.Key === key &&
          TareasStore.TareasConfiguracion.some((t) => t.Key === key)
        ) {
          return true;
        }
      }
    }
    return false;
  };
  const generarHtml = (
    proyecto: ProyectoExtend | null,
    productoAcabado: ProductoAcabadoExtend | null,
    materiales: MaterialExtend[] | null,
    tarea: TareaBBDDExtend | null,
    plantillaEmail: string
  ) => {
    const CommonStore = useCommonStore();
    let result = null;
    switch (plantillaEmail) {
      case "EmailMateriales":
        result = { ...CommonStore.EmailMateriales };
        break;
      case "InicioTareasAsignadas":
        result = { ...CommonStore.EmailInicioTareasAsignadas };
        break;
      case "TareasASignadas":
        result = { ...CommonStore.EmailTareasAsignadas };
      break
      case 'TareasAsignadasNuevosItems':
        result = { ...CommonStore.EmailTareasAsignadasNuevosItems}
    }
    if (proyecto && result) {
      

//  NUEVO: condicionales de 'proyecto' en Body
result.Body = applyConditionalSections(result.Body, proyecto as any, "proyecto");

      for (const key in proyecto) {
        if (Object.prototype.hasOwnProperty.call(proyecto, key)) {
          const regex = new RegExp(`{{proyecto.${key}}}`, "g");
          result.Body = result.Body.replace(regex, proyecto[key]);
        }
      }
    }
    if (productoAcabado && result) {
      
// NUEVO: condicionales de 'PA' en Body
    result.Body = applyConditionalSections(result.Body, productoAcabado as any, "PA");

      for (const key in productoAcabado) {
        if (Object.prototype.hasOwnProperty.call(productoAcabado, key)) {
          const regex = new RegExp(`{{PA.${key}}}`, "g");
          result.Body = result.Body.replace(regex, productoAcabado[key]);
        }
      }
    }
    if (tarea && result) {
      
  // NUEVO: condicionales de 'tarea' en Body
    result.Body = applyConditionalSections(result.Body, tarea as any, "tarea");

      for (const key in tarea) {
        if (Object.prototype.hasOwnProperty.call(tarea, key)) {
          const regex = new RegExp(`{{tarea.${key}}}`, "g");
          result.Body = result.Body.replace(regex, tarea[key]);
        }
      }
    }

    if (materiales && result) {
      // Encontrar el bloque de materiales
      const materialesRegex = /{{@materiales}}([\s\S]*?){{\/@materiales}}/gi;
      const materialesMatch = materialesRegex.exec(result.Body);

      if (materialesMatch && materialesMatch.length > 1) {
        const materialesTemplate = materialesMatch[1];
        let filasMateriales = "";

        // Generar las filas de la tabla de materiales
        materiales.forEach((material) => {
          let fila = materialesTemplate;
          
 // NUEVO: aplica secciones condicionales de 'material' sobre la fila
        fila = applyConditionalSections(fila, material as any, "material");

          for (const key in material) {
            if (Object.prototype.hasOwnProperty.call(material, key)) {
              const regex = new RegExp(`{{material.${key}}}`, "gi");
              fila = fila.replace(regex, material[key]);
            }
          }
          filasMateriales += fila;
        });

        // Reemplazar el bloque de materiales con las filas generadas
        result.Body = result.Body.replace(materialesRegex, filasMateriales);
      }
    }
    return result;
  };

// Se añade funcion para poder poner estilos o condiciones en las plantillas del mail
// Por ejemplo {{#material.CambioDiseno}}style="background-color:#fde68a;" bgcolor="#FDE68A"{{/material.CambioDiseno}}
// Todo lo que esta en medio, solo se "pinta" si materia.CambioDiseno es true.
// Si se quiere poner al reves, que sea falso para que se cumpla, se indica {{^material.CambioDiseno}}style="background-color:#fde68a;" bgcolor="#FDE68A"{{/material.CambioDiseno}}
function applyConditionalSections(body: string, obj: Record<string, any>, prefix: string): string {
  if (!body) return body;

  // Bloques cuando es TRUE: {{#prefix.key}}...{{/prefix.key}}
  const trueSectionRegex = new RegExp(
    `{{#${prefix}\\.(\\w+)}}([\\s\\S]*?){{\\/${prefix}\\.\\1}}`,
    "gi"
  );

  body = body.replace(trueSectionRegex, (_match, key: string, content: string) => {
    const val = obj?.[key];
    const truthy =
      val === true ||
      val === 1 ||
      val === "1" ||
      (typeof val === "string" && val.toLowerCase() === "true");
    return truthy ? content : "";
  });

  // Bloques cuando es FALSE: {{^prefix.key}}...{{/prefix.key}}
  const falseSectionRegex = new RegExp(
    `{{\\^${prefix}\\.(\\w+)}}([\\s\\S]*?){{\\/${prefix}\\.\\1}}`,
    "gi"
  );

  body = body.replace(falseSectionRegex, (_match, key: string, content: string) => {
    const val = obj?.[key];
    const truthy =
      val === true ||
      val === 1 ||
      val === "1" ||
      (typeof val === "string" && val.toLowerCase() === "true");
    return truthy ? "" : content;
  });

  return body;

}

function parseFecha(fecha?: string | null): Date | null {
  if (!fecha || typeof fecha !== "string") return null;

  // 1) ISO u otros formatos reconocidos por Date.parse (incluye YYYY-MM-DD, YYYY-MM-DDTHH:mm:ss)
  const t = Date.parse(fecha);
  if (!Number.isNaN(t)) return new Date(t);

  // 2) DD/MM/YYYY (con o sin hora HH:mm[:ss])
  let m = fecha.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
  if (m) {
    const dia  = Number(m[1]);
    const mes  = Number(m[2]) - 1; // 0-based
    const anyo = Number(m[3]);
    const hh   = m[4] ? Number(m[4]) : 0;
    const mm   = m[5] ? Number(m[5]) : 0;
    const ss   = m[6] ? Number(m[6]) : 0;
    const d = new Date(anyo, mes, dia, hh, mm, ss);
    if (d.getFullYear() === anyo && d.getMonth() === mes && d.getDate() === dia) {
      return d;
    }
  }

  // 3) DD-MM-YYYY (con o sin hora HH:mm[:ss])
  m = fecha.match(/^(\d{2})-(\d{2})-(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
  if (m) {
    const dia  = Number(m[1]);
    const mes  = Number(m[2]) - 1;
    const anyo = Number(m[3]);
    const hh   = m[4] ? Number(m[4]) : 0;
    const mm   = m[5] ? Number(m[5]) : 0;
    const ss   = m[6] ? Number(m[6]) : 0;
    const d = new Date(anyo, mes, dia, hh, mm, ss);
    if (d.getFullYear() === anyo && d.getMonth() === mes && d.getDate() === dia) {
      return d;
    }
  }

  // Si nada coincide, tratamos como “vacía”
  return null;
}

function compareFolderThenFechaAsc(a: any, b: any): number {
  const da = parseFecha(a?.FechaInicio);
  const db = parseFecha(b?.FechaInicio);

  // ✅ Vacías primero (por tu regla: sin fecha = carpeta)
  if (!da && db) return -1;   // a vacío => a primero
  if (da && !db) return 1;    // b vacío => b primero

  // Ambos vacíos => mantener orden relativo (sort estable)
  if (!da && !db) return 0;

  // Ambos con fecha válida => ascendente
  return da!.getTime() - db!.getTime();
}

function sortChildrenRecursively(nodes: any[]): void {
  if (!Array.isArray(nodes)) return;

  nodes.forEach(n => {
    if (Array.isArray(n.children) && n.children.length > 0) {
      n.children.sort(compareFolderThenFechaAsc);
      sortChildrenRecursively(n.children);
    }
  });
}

  return {
    dateToString,
    dateToStringFormatter,
    groupBy,
    getDistinct,
    DaysSince,
    GetClassByStatus,
    removeSpecialCharacters,
    findMissingNumber,
    generateKeyEquipos,
    keyExistsEquipos,
    generarHtml,
    sortChildrenRecursively
  };
}
